import React from 'react';

type Props = {
  visible: boolean;
  x: number;
  y: number;
  text: string;
};

export function GlobeTooltip({ visible, x, y, text }: Props) {
  if (!visible) return null;
  return (
    <div
      style={{
        position: 'absolute',
        left: x,
        top: y,
        transform: 'translate(-50%, -130%)',
        background: 'rgba(8, 12, 24, 0.92)',
        border: '1px solid var(--color-border)',
        color: 'var(--color-text)',
        padding: '6px 12px',
        fontSize: 13,
        fontFamily: 'var(--font-body)',
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        borderRadius: 2,
        zIndex: 10
      }}
    >
      {text}
    </div>
  );
}
